var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#2E5CF6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.792 7.17089C11.979 7.36721 11.9714 7.67794 11.7751 7.86494L8.33843 11.1385C8.14883 11.3191 7.85086 11.3191 7.66125 11.1385L4.22459 7.86494C4.02827 7.67794 4.02072 7.36721 4.20772 7.17089C4.39472 6.97458 4.70545 6.96703 4.90176 7.15403L7.99984 10.1051L11.0979 7.15403C11.2942 6.96703 11.605 6.97458 11.792 7.17089ZM11.792 4.55271C11.979 4.74902 11.9714 5.05976 11.7751 5.24676L8.33843 8.52036C8.14883 8.70096 7.85086 8.70096 7.66125 8.52036L4.22459 5.24676C4.02827 5.05976 4.02072 4.74902 4.20772 4.55271C4.39472 4.3564 4.70545 4.34885 4.90176 4.53584L7.99984 7.48692L11.0979 4.53585C11.2942 4.34885 11.605 4.3564 11.792 4.55271Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowDown);
export default __webpack_public_path__ + "static/media/double-arrow-down.e03f7324.svg";
export { ForwardRef as ReactComponent };